import { Component, Emit, Prop, Provide, Ref, Vue } from 'vue-property-decorator'
import { BModal } from 'bootstrap-vue'
import { cloneDeep } from 'lodash'
import ConfigurationSubportionStateMachinesModalBasicForm
    from '@/modules/configurationModule/detail/local-laboratory-module/subportion-state-machines/components/modal-basic-form/configuration-subportion-state-machines-modal-basic-form.vue'
import {
    initialSubportionStateMachineConfigurationModalState,
    SubportionStateMachineConfigurationModalState
} from '@/modules/configurationModule/detail/local-laboratory-module/subportion-state-machines/components/modal/configuration-subportion-state-machines-grid-modal.model'
import {
    SubportionStateMachineConfigurationCreateRequest,
    SubportionStateMachineConfigurationPatchInBatchRequest, SubportionStateMachineConfigurationResponse
} from '@/modules/configurationModule/detail/local-laboratory-module/subportion-state-machines/services/configuration-subportion-state-machines/configuration-subportion-state-machines.dto'

@Component({
    components: {
        ConfigurationSubportionStateMachinesModalBasicForm
    }
})
export default class ConfigurationSubportionStateMachinesModal extends Vue {
    @Ref() readonly configurationSubportionStateMachinesModal!: BModal

    @Prop(String) readonly actionTitle!: string

    @Prop(Number) readonly sectionId!: number

    @Provide() externalValidator = this.$validator

    @Emit()
    create(): SubportionStateMachineConfigurationCreateRequest {
        return {
            filePath: this.state.filePath,
            sectionId: this.state.section!.id,
            subportionTypeId: this.state.subportionType!.sptId
        }
    }

    @Emit()
    update(): SubportionStateMachineConfigurationPatchInBatchRequest {
        return {
            id: this.state.id!,
            filePath: this.state.filePath
        }
    }

    @Emit()
    hideModal(): boolean {
        return true
    }

    state: SubportionStateMachineConfigurationModalState

    private get _updateMode(): boolean {
        return !!this.state.id
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    constructor() {
        super()
        this.state = initialSubportionStateMachineConfigurationModalState()
    }

    async show(subportionStateMachinesConfiguration?: SubportionStateMachineConfigurationResponse): Promise<void> {
        await this.$validator.reset()

        this.state = initialSubportionStateMachineConfigurationModalState()
        if (subportionStateMachinesConfiguration) {
            this.state = cloneDeep(subportionStateMachinesConfiguration)
        }
        this.state.sectionIdFromParams = this.sectionId

        this.configurationSubportionStateMachinesModal.show()
    }

    hide(): void {
        this.configurationSubportionStateMachinesModal.hide()
        this.hideModal()
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this._updateMode) {
                this.update() // emits an event
            } else {
                this.create() // emits an event
            }
        }
    }
}
